import MESSAGES from 'core/data-model/constants/bi-messages'

export const getInsuredFullName = ({ firstName, lastName } = {}) => {
  return [firstName || MESSAGES.DEFAULT_FIRSTNAME, lastName || MESSAGES.DEFAULT_LASTNAME].join(' ')
}
